import React from 'react';
import DocumentMeta from 'react-document-meta';

function SEO({children,prop}){
    return (
        <>
            <DocumentMeta meta={prop.meta} {...prop}>
                {children}
            </DocumentMeta>

        </>
    );
}
export default SEO
